import moment from "moment";

export function getFormattedDate(date, format) {
  const finalFormat = format || "MM/DD/YYYY HH:mm:ss";
  return moment(date).format(finalFormat);
}
